<template>
  <div id="app">
    <div class="top_main">
      <video :src="topvideo" autoplay muted loop class="bg"></video>
      <img src="../assets/logo.png" alt class="logo" />
      <div class="fun_dom">
        <div class="qr_">
          <img src="../assets/pc/qr.png" alt class="qr" />
        </div>
        <div class="download_">
          <a :href="urlList.ios_url" target="_blank">
            <img src="../assets/pc/app.png" alt class="app" />
          </a>
          <a :href="urlList.android_url" target="_blank">
            <img src="../assets/pc/google.png" alt class="google" />
          </a>
          <a :href="urlList.apk_url" target="_blank">
            <img src="../assets/pc/mycard.png" alt class="mycard" />
          </a>
        </div>
      </div>
      <img src="../assets/pc/godown.png" alt class="godown" />
    </div>
    <div class="pic_main pcMain" ref="pic_big">
      <img src="../assets/pc/gamepic/bg.jpg" alt class="bg" />
      <div class="title">
        <img src="../assets/pc/gamepic/title.png" alt class="title" />
      </div>
      <transition enter-active-class="animate__animated animate__fadeInUp"
        leave-active-class="animate__animated animate__fadeOutUp">
        <div class="pic_dom" v-if="pic_show">
          <div class="pic_big">
            <transition enter-active-class="animate__animated animate__fadeIn">
              <div class="pic_big_" v-if="pic == 1">
                <img src="../assets/pc/gamepic/campsBig.png" alt />
              </div>
            </transition>
            <transition enter-active-class="animate__animated animate__fadeIn">
              <div class="pic_big_" v-if="pic == 2">
                <img src="../assets/pc/gamepic/daynightBig.png" alt />
              </div>
            </transition>
            <transition enter-active-class="animate__animated animate__fadeIn">
              <div class="pic_big_" v-if="pic == 3">
                <img src="../assets/pc/gamepic/groupBig.png" alt />
              </div>
            </transition>
            <transition enter-active-class="animate__animated animate__fadeIn">
              <div class="pic_big_" v-if="pic == 4">
                <img src="../assets/pc/gamepic/militaryBig.png" alt />
              </div>
            </transition>
            <transition enter-active-class="animate__animated animate__fadeIn">
              <div class="pic_big_" v-if="pic == 5">
                <img src="../assets/pc/gamepic/manorBig.png" alt />
              </div>
            </transition>
          </div>
          <div class="pic_small">
            <div class="pic_small_" :class="pic == 1 ? 'active' : ''" @mouseover="showBig(1)">
              <img src="../assets/pc/gamepic/camps.png" alt />
            </div>
            <div class="pic_small_" :class="pic == 2 ? 'active' : ''" @mouseover="showBig(2)">
              <img src="../assets/pc/gamepic/daynight.png" alt />
            </div>
            <div class="pic_small_" :class="pic == 3 ? 'active' : ''" @mouseover="showBig(3)">
              <img src="../assets/pc/gamepic/group.png" alt />
            </div>
            <div class="pic_small_" :class="pic == 4 ? 'active' : ''" @mouseover="showBig(4)">
              <img src="../assets/pc/gamepic/military.png" alt />
            </div>
            <div class="pic_small_" :class="pic == 5 ? 'active' : ''" @mouseover="showBig(5)">
              <img src="../assets/pc/gamepic/manor.png" alt />
            </div>
          </div>
        </div>
      </transition>
    </div>
    <div class="video_main" ref="video_dialog">
      <img src="../assets/pc/gamevideo/bg.jpg" alt class="bg" />
      <img src="../assets/pc/gamevideo/title.png" alt class="title" />
      <transition-group enter-active-class="animate__animated animate__fadeInUp"
        leave-active-class="animate__animated animate__fadeOutUp">
        <div class="video_dom" v-if="vd_show" :key="1">
          <img src="../assets/pc/gamevideo/frame.png" alt class="iframe" />
          <img src="../assets/pc/gamevideo/play.png" alt class="play" :class="play_btn == 1 ? 'offplay' : ''"
            @click="play()" />
          <div class="video_" v-for="(item, index) in video_list" :key="item.id">
            <video :src="item.url" :poster="item.imgUrl" controls id="videos" v-if="video_in == index"></video>
          </div>
        </div>
        <img src="../assets/pc/gamevideo/listbg.png" alt class="listbg" v-if="vd_show" :key="2" />
        <div class="video_list" v-if="vd_show" :key="3">
          <div class="prev" :class="v_control == 0 ? 'no_click' : ''" @click="prev">
            <img src="../assets/pc/gamevideo/left.png" alt />
          </div>
          <div class="pic_">
            <div class="pic_list" id="picL" ref="pic_list" :style="{ transform: `translateX(${transfromX}px)` }">
              <div class="pic_item" v-for="(item, index) in video_list" :key="index" @click="changeVideo(index)">
                <img :class="item.id == video_in ? 'active' : ''" :src="item.imgUrl" alt />
                <img src="../assets/pc/gamevideo/play.png" alt class="item_play"
                  :class="item.id == video_in ? 'actives' : ''" />
                <p>{{ item.name }}</p>
              </div>
            </div>
          </div>
          <div class="next" :class="v_control == 1 ? 'no_click' : ''" @click="next">
            <img src="../assets/pc/gamevideo/right.png" alt />
          </div>
        </div>
      </transition-group>
    </div>
    <div class="fb_main" ref="fb_dialog">
      <img src="../assets/pc/gamefb/bg.jpg" alt class="bg" />
      <img src="../assets/pc/gamefb/title.png" alt class="title" />
      <transition-group enter-active-class="animate__animated animate__fadeInUp"
        leave-active-class="animate__animated animate__fadeOutUp">
        <div class="fb_dialog_dom" :key="1" v-show="fb_show">
          <div class="abs fbFans" ref="fbFansRef">
            <div
              :style="{
                width: fbFansWidth + 'px',
                height: fbFansHeight,
                transform: `scale(${
                  fbFansWidth > 680
                    ? 1.34
                    : fbFansWidth > 670
                    ? 1.32
                    : fbFansWidth > 660
                    ? 1.3
                    : fbFansWidth > 650
                    ? 1.28
                    : fbFansWidth > 640
                    ? 1.26
                    : fbFansWidth > 630
                    ? 1.244
                    : fbFansWidth > 620
                    ? 1.22
                    : fbFansWidth > 610
                    ? 1.204
                    : fbFansWidth > 600
                    ? 1.191
                    : fbFansWidth > 590
                    ? 1.17
                    : fbFansWidth > 580
                    ? 1.15
                    : fbFansWidth > 570
                    ? 1.13
                    : fbFansWidth > 560
                    ? 1.11
                    : fbFansWidth > 550
                    ? 1.09
                    : fbFansWidth > 540
                    ? 1.07
                    : fbFansWidth > 530
                    ? 1.05
                    : fbFansWidth > 520
                    ? 1.032
                    : fbFansWidth > 510
                    ? 1.012
                    : fbFansWidth > 500
                    ? 0.985
                    : 1
                })`
              }"
              class="fb-page"
              data-href="https://www.facebook.com/3KD.MFG"
              data-show-posts="true"
              data-width="500"
              data-height="640"
              data-small-header="false"
              data-adapt-container-width="true"
              data-hide-cover="false"
              data-show-facepile="true"
            >
              <blockquote
                cite="https://www.facebook.com/3KD.MFG"
                class="fb-xfbml-parse-ignore"
              >
                <a href="https://www.facebook.com/3KD.MFG">新三國 漢室復興</a>
              </blockquote>
            </div>
          </div>
        </div>

        <img src="../assets/pc/gamefb/fream.png" alt class="fb_dialog_dom_frame" :key="2" v-if="fb_show" />
      </transition-group>
      <div class="footer_">
        <img src="../assets/pc/footer.png" alt class="footer_bg" />
        <ul class="test_bg">
          <a href="https://www.gamemorefun.com/#/" target="_blank">
            <li></li>
          </a>
          <a href="https://www.gamemorefun.com/#/footerDetail/15" target="_blank">
            <li></li>
          </a>
          <a href="https://www.gamemorefun.com/#/footerDetail/17" target="_blank">
            <li></li>
          </a>
          <a href="https://www.gamemorefun.com/front/policy" target="_blank">
            <li></li>
          </a>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import topvideo from "../../public/head.mp4";
import video1 from "../../public/video/0.mp4";
import video2 from "../../public/video/1.mp4";
import video3 from "../../public/video/2.mp4";
import video4 from "../../public/video/3.mp4";
import video5 from "../../public/video/4.mp4";
import video6 from "../../public/video/5.mp4";
import img5 from "../../public/video/5.png";
import video7 from "../../public/video/6.mp4";
import img6 from "../../public/video/6.png";
import video8 from "../../public/video/7.mp4";
import img7 from "../../public/video/7.png";
import video9 from "../../public/video/8.mp4";
import img8 from "../../public/video/8.png";
export default {
  name: "App",
  components: {},
  data: function () {
    return {
      pic: 1,
      pic_show: false,
      fb_show: false,
      vd_show: false,
      video_in: 0,
      v_control: 0,
      transfromX: 0,
      listInArray: [],
      play_in: 0,
      play_btn: 0,
      topvideo: topvideo,
      tabpages: { pages: 100, pageNum: 1 },
      urlList: { ios_url: '', fb_fans_url: '', apk_url: '', android_url: '' },
      // Facebook 显示策略控制
      showOfficialIframe: true,
      showFallbackCard: false,
      iframeLoadFailed: false,
      connectionRefused: false,
      loadingTimeout: null,
      facebookSDKLoaded: false,
      fbFansWidth: 500,
      fbFansHeight: 640,
      video_list: [
        {
          id: 0,
          url: video6,
          name: "許紹雄&郭峰 梟雄對弈",
          imgUrl: img5,
        },
        {
          id: 1,
          url: video7,
          name: "許紹雄：我要改朝換代",
          imgUrl: img6,
        },
        {
          id: 2,
          url: video8,
          name: "姜皓文：我的軍團有內奸",
          imgUrl: img7,
        },
        {
          id: 3,
          url: video9,
          name: "姜皓文：我要的是整個中原",
          imgUrl: img8,
        },
        {
          id: 4,
          url: video1,
          name: "《新三国 漢室復興》-攻城战",
          imgUrl: "https://3kd.gamemorefun.net/video/0.png",
        },
        {
          id: 5,
          url: video2,
          name: "《新三國 漢室復興》CG",
          imgUrl: "https://3kd.gamemorefun.net/video/1.png",
        },
        {
          id: 6,
          url: video3,
          name: "《新三國 漢室復興》-風雲篇1",
          imgUrl: "https://3kd.gamemorefun.net/video/2.png",
        },
        {
          id: 7,
          url: video4,
          name: "《新三國 漢室復興》玩法內容",
          imgUrl: "https://3kd.gamemorefun.net/video/3.png",
        },
        {
          id: 8,
          url: video5,
          name: "《新三國 漢室復興》-演武戰",
          imgUrl: "https://3kd.gamemorefun.net/video/4.png",
        },
      ],
    };
  },
  mounted: function () {
    let that = this;
    let throttleScroll = this.throttle(that.init_scroll, 300);
    window.addEventListener("scroll", function () {
      throttleScroll();
    });
    window.fbAsyncInit = function () {
      FB.init({
        appId: "1407439736082162",
        cookie: true,
        xfbml: true, // 解析此页面上的社交插件
        version: "v24.0", // 使用最新版本
      });

      // Facebook SDK 加载完成后解析页面插件
      FB.XFBML.parse();

      // 设置加载成功标志
      that.facebookSDKLoaded = true;
    };
    if (this.video_list.length < 5) {
      this.v_conturl = 0;
    }
    this.listInArray = [0, 3];
    this.$axios.post('https://api.hermesgames.com.tw/front/game/url', { appid: 'bmccfg', timestamp: +new Date() }).then(response => {
      if (response.data.status == 2000) {
        that.urlList = response.data.data
      }
    })

    // 初始化 Facebook 显示策略
    this.initFacebookDisplayStrategy();

    // 添加窗口大小监听器
    this.updateFbFansSize();
    window.addEventListener('resize', this.updateFbFansSize);

  },
  watch: {
    vd_show(n, o) {
      if (n) {
        this.$nextTick(function () {
          this.init_video();
          this.$refs["pic_list"].style.width =
            this.video_list.length * 250 + "px";
          this.get_item();
        });
      }
    },
    video_in(n, o) {
      this.$nextTick(function () {
        this.init_video();
      });
      if (n == 0) {
        this.v_control = 0;
      } else if (n == this.video_list.length - 1) {
        this.v_control = 1;
      } else {
        this.v_control = 2;
      }
    },
    fb_show(n, o) {
      if (n) {
        this.$nextTick(() => {
          // 更新容器尺寸
          this.updateFbFansSize();

          // 如果Facebook SDK已加载，重新解析插件
          if (window.FB && window.FB.XFBML) {
            setTimeout(() => {
              window.FB.XFBML.parse();
              console.log('🔄 Facebook插件重新解析并适配到.fbFans容器');
            }, 300);
          }
        });
      }
    },
  },
  destroyed: function() {
    // 移除窗口大小监听器
    window.removeEventListener('resize', this.updateFbFansSize);
  },
  methods: {
    // 更新Facebook粉丝页尺寸
    updateFbFansSize: function() {
      this.$nextTick(() => {
        if (this.$refs.fbFansRef) {
          // 获取.fbFans容器的实际可用空间
          const fbFansContainer = this.$refs.fbFansRef;
          const containerWidth = fbFansContainer.offsetWidth;
          const containerHeight = fbFansContainer.offsetHeight;

          // 计算最适合的尺寸，考虑容器的padding和margin
          const computedStyle = window.getComputedStyle(fbFansContainer);
          const paddingLeft = parseFloat(computedStyle.paddingLeft) || 0;
          const paddingRight = parseFloat(computedStyle.paddingRight) || 0;
          const paddingTop = parseFloat(computedStyle.paddingTop) || 0;
          const paddingBottom = parseFloat(computedStyle.paddingBottom) || 0;

          // 可用宽度和高度
          const availableWidth = containerWidth - paddingLeft - paddingRight;
          const availableHeight = containerHeight - paddingTop - paddingBottom;

          // 设置Facebook页面的基础尺寸，最大不超过500px
          this.fbFansWidth = Math.min(Math.max(availableWidth, 300), 500);

          // 固定高度为640px，确保适配容器
          this.fbFansHeight = 640;

          console.log(`📏 Facebook粉丝页尺寸调整: ${this.fbFansWidth}x${this.fbFansHeight}, 容器: ${containerWidth}x${containerHeight}`);
        } else {
          // 如果ref还没有准备好，使用默认尺寸
          this.fbFansWidth = 500;
          this.fbFansHeight = 640;
        }
      });
    },

    changeVideo: function (e) {
      this.play_btn = 0;
      this.video_in = e;
    },
    prev: function () {
      if (this.video_in == 0) return; //无法左滑
      this.video_in -= 1;
      let listInArray = this.listInArray;
      let max = Math.max(...listInArray);
      let min = Math.min(...listInArray);
      if (this.video_in < min) {
        this.transfromX += this.get_item();
        this.listInArray = [];
        this.listInArray.push(this.video_in);
        this.listInArray.push(max - 1);
      }
      // let that = this
      // setTimeout(function(){
      //    that.init_video()
      // },500)
    },
    next: function () {
      if (this.video_in == this.video_list.length - 1) return;
      this.video_in += 1;
      let listInArray = this.listInArray;
      let max = Math.max(...listInArray);
      let min = Math.min(...listInArray);
      if (this.video_in > max) {
        this.transfromX = -(this.get_item() * (this.video_in - 3));
        this.listInArray = [];
        this.listInArray.push(min + 1);
        this.listInArray.push(this.video_in);
      }
      // let that = this

      // setTimeout(function(){
      //    that.init_video()
      // },500)
    },
    play: function () {
      let that = this;
      this.play_btn = 1;
      let dom = document.getElementById("videos");
      dom.play();
      this.init_video();
    },
    init_video: function () {
      let that = this;
      let dom = document.getElementById("videos");

      dom.addEventListener("pause", function () {
        that.play_btn = 0;
      });
      dom.addEventListener("play", function () {
        that.play_btn = 1;
      });
      dom.addEventListener("end", function () {
        that.play_btn = 0;
      });
    },
    get_item: function () {
      let dom = document.querySelector(".pic_item");
      let width, marginRight;
      if (window.getComputedStyle) {
        width = window.getComputedStyle(dom, null).width;
        marginRight = window.getComputedStyle(dom, null).marginRight;
      } else {
        width = dom.currentStyle.width;
        marginRight = dom.currentStyle.marginRight;
      }
      return (
        Number(width.substring(0, width.length - 2)) +
        Number(marginRight.substring(0, marginRight.length - 2))
      );
    },
    // Facebook 显示策略初始化
    initFacebookDisplayStrategy: function () {
      console.log('🔍 Initializing Facebook display strategy...');

      // 检测不支持 iframe 的浏览器
      if (this.isUnsupportedBrowser()) {
        console.log('❌ Unsupported browser detected, using fallback card');
        this.showOfficialIframe = false;
        this.showFallbackCard = true;
        return;
      }

      // 预检测 Facebook 连接状态
      this.checkFacebookConnection();

      // 设置超时检测
      this.loadingTimeout = setTimeout(() => {
        if (this.showOfficialIframe && !this.iframeLoadFailed) {
          console.log('⏰ Iframe loading timeout, switching to fallback card');
          this.switchToFallbackCard('timeout');
        }
      }, 8000); // 8秒超时
    },

    // 检测 Facebook 连接状态
    checkFacebookConnection: function () {
      console.log('🔗 Checking Facebook connection...');

      // 创建测试图片来检测 Facebook 连接
      const testImage = new Image();
      const testTimeout = setTimeout(() => {
        console.log('❌ Facebook connection test timeout - likely blocked');
        this.handleConnectionRefused();
      }, 8000); // 增加超时时间到8秒

      testImage.onload = () => {
        console.log('✅ Facebook connection test successful');
        clearTimeout(testTimeout);

        // 连接成功后，等待SDK加载完成再解析
        this.waitForFacebookSDK();
      };

      testImage.onerror = () => {
        console.log('❌ Facebook connection refused or blocked');
        clearTimeout(testTimeout);
        this.handleConnectionRefused();
      };

      // 使用 Facebook CDN 资源进行连接测试
      testImage.src = 'https://connect.facebook.net/favicon.ico?_=' + Date.now();
    },

    // 等待Facebook SDK加载完成
    waitForFacebookSDK: function() {
      let checkCount = 0;
      const maxChecks = 20; // 最多检查20次（10秒）

      const checkSDK = () => {
        if (window.FB && window.FB.XFBML) {
          console.log('✅ Facebook SDK loaded successfully');

          // 重新解析页面插件
          window.FB.XFBML.parse();

          // 等待插件解析完成后调整尺寸
          setTimeout(() => {
            this.updateFbFansSize();
            console.log('🎯 Facebook粉丝页已适配到.fbFans容器');
          }, 1000);

          return;
        }

        checkCount++;
        if (checkCount < maxChecks) {
          setTimeout(checkSDK, 500);
        } else {
          console.log('❌ Facebook SDK failed to load, switching to fallback');
          this.switchToFallbackCard('sdk_load_failed');
        }
      };

      setTimeout(checkSDK, 500);
    },

    // 处理连接被拒绝的情况
    handleConnectionRefused: function () {
      console.log('🚫 Facebook connection refused, switching to fallback card');
      this.connectionRefused = true;
      this.switchToFallbackCard('connection_refused');
    },

    // 检测不支持的浏览器
    isUnsupportedBrowser: function () {
      const userAgent = navigator.userAgent.toLowerCase();

      // Firefox 特殊处理
      if (userAgent.includes('firefox')) {
        console.log('🦊 Firefox detected');
        return true;
      }

      // 检测其他可能有问题的浏览器
      const unsupportedBrowsers = [
        'edge/',  // 旧版 Edge
        'trident/', // IE
        'kaios', // KaiOS
      ];

      return unsupportedBrowsers.some(browser => userAgent.includes(browser));
    },

    // iframe 加载成功回调
    onIframeLoad: function () {
      console.log('✅ Facebook iframe loaded successfully');

      // 清除超时检测
      if (this.loadingTimeout) {
        clearTimeout(this.loadingTimeout);
        this.loadingTimeout = null;
      }

      // 检测 iframe 内容是否真正加载
      setTimeout(() => {
        if (!this.checkIframeContent()) {
          console.log('❌ Iframe loaded but content is empty, switching to fallback');
          this.switchToFallbackCard();
        }
      }, 3000);
    },

    // iframe 加载错误回调
    onIframeError: function (event) {
      console.log('❌ Facebook iframe failed to load:', event);

      // 检查是否是连接被拒绝
      if (event && event.type === 'error') {
        console.log('🚫 Detected connection refusal or network error');
        this.connectionRefused = true;
      }

      this.iframeLoadFailed = true;
      this.switchToFallbackCard('iframe_error');
    },

    // 检测 iframe 内容是否加载成功
    checkIframeContent: function () {
      try {
        const iframe = this.$refs.facebookIframe;
        if (!iframe) return false;

        // 检测 iframe 是否可访问 (同源策略限制，这里主要检测是否存在)
        return iframe.contentWindow !== null;
      } catch (error) {
        console.log('Cannot access iframe content due to CORS policy (this is expected)');
        return true; // 由于同源策略，无法检测内容，假设成功
      }
    },

    // 切换到备用卡片显示
    switchToFallbackCard: function (reason = 'unknown') {
      console.log(`🔄 Switching to fallback card, reason: ${reason}`);

      this.showOfficialIframe = false;
      this.showFallbackCard = true;

      // 清除超时检测
      if (this.loadingTimeout) {
        clearTimeout(this.loadingTimeout);
        this.loadingTimeout = null;
      }

      // 记录切换原因用于分析
      this.trackFallbackReason(reason);
    },

    // 追踪切换到备用方案的原因
    trackFallbackReason: function (reason) {
      console.log(`📊 Fallback reason tracked: ${reason}`);

      // Google Analytics 追踪
      if (window.gtag) {
        window.gtag('event', 'facebook_fallback', {
          'event_category': 'social',
          'event_label': reason,
          'custom_parameter_1': navigator.userAgent
        });
      }

      // 可以添加其他统计服务
      // 例如发送到自己的服务器记录
    },

    // Facebook 点击追踪
    trackFacebookClick: function () {
      console.log('📊 Facebook page visit tracked');

      // Google Analytics 追踪
      if (window.gtag) {
        window.gtag('event', 'click', {
          'event_category': 'social',
          'event_label': 'facebook_visit_fallback'
        });
      }

      // 其他统计代码可以在这里添加
    },
    showBig: function (e) {
      this.pic = e;
    },
    init_scroll: function () {
      let top =
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        window.pageYOffset;
      let vd_, fb_;
      let that = this;
      this.$nextTick(function () {
        vd_ = that.$refs["video_dialog"].offsetTop;
        fb_ = that.$refs["fb_dialog"].offsetTop;
        if (top > 100) {
          that.pic_show = true;
        }
        if (top + window.innerHeight - vd_ > 150) {
          that.vd_show = true;
        }
        if (top + window.innerHeight - fb_ > 150) {
          that.fb_show = true;
        }
      });
    },
  },
};
</script>

<style lang='scss'>
html,
body {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
}

#app {
  width: 100%;
  height: 100%;

  .top_main {
    width: 100%;
    position: relative;
    overflow-x: hidden;

    .bg {
      width: 100%;
      display: block;
    }

    .logo {
      position: absolute;
      width: 3.4rem;
      top: 0.3rem;
      left: 50%;
      margin-left: -8rem;
    }

    .fun_dom {
      width: 3rem;
      height: 1.5rem;
      position: absolute;
      top: 50%;
      margin-top: 1.5rem;
      left: 50%;
      margin-left: -1.5rem;
      display: flex;
      flex-flow: row wrap;
      justify-content: space-around;
      align-items: center;

      .qr_ {
        width: 50%;
        height: 100%;

        img {
          display: block;
          width: 100%;
        }
      }

      .download_ {
        width: 1.35rem;

        a {
          display: block;
          line-height: 0.2rem;
        }

        .app,
        .google,
        .mycard {
          width: 1.35rem;
          display: block;
          margin-bottom: 0.04rem;
        }
      }
    }

    .godown {
      position: absolute;
      width: 0.37rem;
      top: 50%;
      margin-top: 3.8rem;
      left: 50%;
      margin-left: -0.2rem;
    }
  }

  .pic_main {
    width: 100%;
    position: relative;
    overflow: hidden;

    .bg {
      width: 100%;
      display: block;
    }

    .title {
      width: 19rem;
      position: absolute;
      top: 0;
      left: 0;
    }

    .pic_dom {
      width: 13.25rem;
      top: 50%;
      margin-top: -2.4rem;
      left: 50%;
      margin-left: -6.625rem;
      position: absolute;

      img {
        display: block;
      }

      .pic_big {
        width: 100%;
        margin-bottom: 0.5rem;
        height: 4.1rem;
        overflow: hidden;

        .pic_big_ {
          width: 100%;
        }
      }

      .pic_small {
        width: 116%;
        display: flex;
        flex-flow: row wrap;
        justify-content: space-around;
        margin-left: -8%;

        .pic_small_ {
          width: 2.6rem;
          height: 1.465rem;
          cursor: default;
          border: 3px solid rgba(0, 0, 0, 0);
          transition: 0.3s border linear;
        }

        .active {
          border: 3px solid #ba9e5a;
        }
      }
    }

    .small_dom {
      width: 13.25rem;
      top: 50%;
      margin-top: -3.5rem;
      left: 50%;
      margin-left: -6.625rem;
      position: absolute;
    }
  }

  .video_main {
    width: 100%;
    position: relative;
    overflow: hidden;

    .bg {
      width: 100%;
      display: block;
    }

    .title {
      width: 18rem;
      position: absolute;
      top: 0;
      right: 0;
    }

    .video_dom {
      width: 9.35rem;
      height: 5.34rem;
      position: absolute;
      top: 50%;
      margin-top: -3rem;
      left: 50%;
      margin-left: -4.67rem;
      overflow: hidden;

      .video_ {
        position: relative;
        z-index: 11;

        video {
          width: 9.1rem;
          height: 5.16rem;
          margin-top: 0.1rem;
          margin-left: 0.12rem;
        }
      }

      .iframe {
        width: 100%;
        height: 100%;
        display: block;
        position: absolute;
        z-index: 10;
      }

      .play {
        width: 1rem;
        height: 1rem;
        position: absolute;
        top: 50%;
        margin-top: -0.5rem;
        left: 50%;
        margin-left: -0.5rem;
        cursor: pointer;
        z-index: 12;
        transition: top 0.3s ease-in;
      }

      .offplay {
        top: 10rem;
      }
    }

    .listbg {
      width: 100%;
      height: 2rem;
      position: absolute;
      bottom: 0.2rem;
      left: 0;
    }

    .video_list {
      width: 100%;
      height: 2rem;
      position: absolute;
      bottom: 0.2rem;
      left: 0;

      .prev {
        width: 0.58rem;
        height: 0.71rem;
        position: absolute;
        left: 50%;
        margin-left: -6rem;
        top: 0.6rem;
        cursor: pointer;

        img {
          display: block;
        }
      }

      .next {
        width: 0.58rem;
        height: 0.71rem;
        position: absolute;
        left: 50%;
        margin-left: 5.42rem;
        top: 0.6rem;
        cursor: pointer;

        img {
          display: block;
        }
      }

      .no_click {
        opacity: 0.4;
      }

      .pic_ {
        width: 9.5rem;
        height: 1.6rem;
        position: absolute;
        top: 0.3rem;
        left: 50%;
        margin-left: -4.7rem;
        overflow: hidden;
      }

      .pic_list {
        transition: all 0.4s ease;

        .pic_item {
          width: 2.1rem;
          float: left;
          margin-right: 0.3rem;
          cursor: pointer;
          position: relative;

          img {
            display: block;
            width: 100%;
            border: 2px solid rgba(0, 0, 0, 0);
            transition: all 0.3s ease-in;
          }

          .active {
            border: 2px solid #ba9e5a;
          }

          .actives {
            opacity: 0.9;
          }

          .item_play {
            position: absolute;
            width: 0.6rem;
            height: 0.6rem;
            top: 50%;
            margin-top: -0.5rem;
            left: 50%;
            margin-left: -0.3rem;
          }
        }

        .pic_item:hover {
          img {
            opacity: 1;
          }
        }

        p {
          margin: 0.05rem 0 0;
          font-size: 0.14rem;
          color: #f7eaca;
          text-align: center;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }

  .fb_main {
    width: 100%;
    position: relative;
    overflow-x: hidden;

    .bg {
      width: 100%;
      display: block;
    }

    .title {
      width: 17rem;
      position: absolute;
      top: 0;
      left: 0;
    }

    .fb_dialog_dom {
      width: 500px;
      height: 640px;
      top: 2.3rem;
      left: 50%;
      margin-left: -250px;
      position: absolute;
      z-index: 3;
      overflow: hidden;

      .abs {
        position: relative;
        width: 100%;
        height: 100%;

        &.fbFans {
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0.2rem;
          box-sizing: border-box;
          background: rgba(255, 255, 255, 0.95);
          border-radius: 8px;
          box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
          overflow: hidden;

          .fb-page {
            transform-origin: center center;
            transition: transform 0.3s ease;
            max-width: 100%;
            max-height: 100%;

            // Facebook插件内部元素适配
            iframe {
              max-width: 100% !important;
              max-height: 100% !important;
            }

            // 加载状态样式
            &:empty::before {
              content: '正在加載Facebook粉絲頁...';
              display: flex;
              align-items: center;
              justify-content: center;
              width: 100%;
              height: 200px;
              color: #666;
              font-size: 14px;
              background: #f5f5f5;
              border-radius: 4px;
            }
          }

          // 响应式适配
          @media (max-width: 768px) {
            padding: 0.1rem;
          }
        }
      }
    }

    .fb_dialog_dom_frame {
      width: 528px;
      height: 6.6rem;
      top: 2.2rem;
      left: 50%;
      margin-left: -264px;
      position: absolute;
    }
  }

  .footer_ {
    position: absolute;
    bottom: 0;
    width: 100%;

    img {
      display: block;
      width: 100%;
    }

    ul {
      position: absolute;
      list-style: none;
      top: 4.2rem;
      left: 6.1rem;
      width: 3.4rem;
      margin: 0;
      padding: 0;

      a {
        display: block;
      }

      li {
        float: left;
        width: 25%;
        height: 0.4em;
      }
    }
  }
}
</style>
